import BaseTable from 'components/Tables/BaseTable';
import FlowListDetailPanel from 'pages/ScenarioExposure/Flow/ScenariosManagement/PROCTrabalhadores/FlowStepListDetailPanel';
import React from 'react';
import { connect } from 'react-redux';
import { lookUpIdValueSelector } from 'selectors/generic';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioConditions';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';
import { currentUser } from 'selectors/currentUser';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(64);

const Component = props => {
  const {
    conditionsById, descriptorId, flowsById, scenariosById, flowScenarioDescriptors,
    scenarioDescriptorConditionsData, stepsById, units, user
  } = props;

  const selectedSD = flowScenarioDescriptors.filter(sd =>
    (descriptorId && sd.descriptor_id === descriptorId)
  );

  let filteredSDC = {};
  const sdcConditionRepetitions = [];

  selectedSD.forEach(sSD => {
    const flowId = scenariosById[sSD.scenario_id].flow_id;
    const flowInfo = {
      flow_id: flowId,
      flow_code: flowsById[flowId].code,
      flow_name: flowsById[flowId].name
    };
    const stepInfo = {
      step_id: sSD.step_id,
      step_code: stepsById[sSD.step_id].name,
      step_name: stepsById[sSD.step_id].master_step_id ?
        stepsById[stepsById[sSD.step_id].master_step_id].description + ' / ' + stepsById[sSD.step_id].description :
        stepsById[sSD.step_id].description
    };
    const sdcs = scenarioDescriptorConditionsData.filter(sdc => sdc.scenario_descriptor_id === sSD.id);
    sdcs.forEach(sdc => {
      if (sdcConditionRepetitions.includes(sdc.condition_id)) {

        // If the FlowInfo for this flowId as already been added to the list then
        // just need to add StepInfo else add everything
        if (Object.keys(filteredSDC[sdc.condition_id].stepsInfo).includes(flowId.toString())) {
          filteredSDC[sdc.condition_id].stepsInfo[flowId] = [
            ...filteredSDC[sdc.condition_id].stepsInfo[flowId],
            stepInfo
          ];
        } else {
          filteredSDC[sdc.condition_id].flowsInfo.push(flowInfo);
          filteredSDC[sdc.condition_id].stepsInfo[flowId] = [stepInfo];
        }

      } else {
        filteredSDC[sdc.condition_id] = {
          ...sdc,
          flowsInfo: [flowInfo],
          stepsInfo: { [flowId]: [stepInfo] }
        };
        sdcConditionRepetitions.push(sdc.condition_id);
      }
    });
  });

  const rows = Object.values(filteredSDC).map(element => {
    const subtype = conditionsById[element.condition_id].subtype;
    const name = conditionsById[element.condition_id].name;
    return { ...element, subtype, name };
  });

  return (
    <React.Fragment>
      <BaseTable
        title={'CONDIÇÕES DO FLUXO'}
        columns={columns(user, units)}
        data={descriptorId ? rows : []}
        paging={false}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: () => ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Flow,
            tooltip: 'Fluxogramas',
            render: ({ rowData }) => <FlowListDetailPanel row={rowData}/>
          })
        ]}
      />
    </React.Fragment>
  );
};

const makemapStateToProps = () => {
  const units = lookUpIdValueSelector('units', ['name']);
  const mapStateToProps = (state, props) => ({
    conditionsById: state.conditions.models,
    flowsById: state.flows.models,
    scenariosById: state.scenarios.models,
    scenarioDescriptorConditionsData: state.scenarioDescriptorConditions.data,
    stepsById: state.steps.models,
    units: units(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

export default connect(makemapStateToProps)(Component);
